/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { BrowserCheck } from "abweb/service/utils/BrowserCheck";
export class BrowserSpecificBugSituations {
  static detect() {
    const name = BrowserCheck.browserName;
    const version = BrowserCheck.version;
    const root = document.documentElement;
    const situations = [
    // Brad: Chrome 72 no longer supported, but keeping this logic in place as an example for when
    // we hit the next browser-specific css bug  that we need to address
    // (see CAT-1829, and EI-17098 as a never-executed-in-current-browser-stack exemplar).
    {
      name: "Chrome",
      version: "72",
      cssClass: "ab-bsbs-001"
    }];
    situations.forEach(x => {
      if (x.name === name && x.version === version) {
        root.classList.add(x.cssClass);
      }
    });
  }
}
//# sourceMappingURL=BrowserSpecficBugSituations.js.map
